import { Badge } from "flowbite-react";
import Loading from "../../components/Loading";
import { Link, useNavigate } from "react-router-dom";
import OrderListActionButton from "../../components/OrderListActionButton";

export const ORDER_OUTLINE = [
  { api_name: "Name", show_name: "Order Id" },
  { api_name: "Versioning_No", show_name: "Order Version" },
  { api_name: "Customer_PO_No", show_name: "Po Number" },
  { api_name: "Date", show_name: "Enquiry Date" },
  { api_name: "Delivery_Date", show_name: "Delivery Date" },
  { api_name: "Stage", show_name: "Status" },
  { api_name: "Request_Type", show_name: "Request Type" },
  { api_name: "Grand_Total", show_name: "Total" },
  { api_name: "Action", show_name: "Actions" },
];

const OrderLists = ({ isLoading, orders, setSearchValues }) => {
  console.log({ orders });
  let navigate = useNavigate();

  const handleApiCall = (selectedValue) => {
    // navigate({
    //   search: `?Stage=${selectedValue}`
    // });
    setSearchValues((searchValues) => {
      return {
        ...searchValues,
        ["Stage"]: selectedValue,
        page: 1,
      };
    });
    // console.log("Selected value:", selectedValue);
  };

  return (
    <div className="max-w-full relative overflow-x-auto shadow-md sm:rounded-lg">
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            {ORDER_OUTLINE.map(({ api_name, show_name }) => (
              <th key={show_name} scope="col" className="px-6 py-3 text-center">
                {show_name === "Status" ? (
                  // <select
                  //   className="p-1 text-center border-0 focus:outline-0 focus:ring-0 focus:border-transparent text-sm bg-gray-50"
                  //   onChange={(e) => handleApiCall(e.target.value)}
                  // >
                  //   <option value="">Select Status</option>
                  //   {/* You can add your stage options here */}
                  //   <option value="Confirm">Stock Confirm</option>
                  //   <option value="Pending For Availability Check">
                  //     Pending For Availability Check
                  //   </option>
                  //   <option value="Void">Void</option>
                  //   <option value="Pending for Approval - CEO">
                  //     Pending for Approval - CEO
                  //   </option>
                  //   <option value="Pending for Approval - Country Manager">
                  //     Pending for Approval - Country Manager
                  //   </option>
                  //   <option value="Approved by Country Manager">
                  //     Approved by Country Manager
                  //   </option>
                  //   <option value="Rejected by Country Manager">
                  //     Rejected by Country Manager
                  //   </option>
                  //   <option value="Rejected - CEO">Rejected - CEO</option>
                  //   <option value="Order Confirm">Order Confirm</option>
                  //   <option value="SO Confirmed">SO Confirmed</option>
                  //   <option value="Order : In Progress">
                  //     Order : In Progress
                  //   </option>
                  //   <option value="Order : Partially Invoiced">
                  //     Order : Partially Invoiced
                  //   </option>
                  //   <option value="Order : Invoiced">Order : Invoiced</option>
                  //   <option value="Order : Void">Order : Void</option>
                  //   <option value="Order : Picking">Order : Picking</option>
                  //   <option value="Order : Packed">Order : Packed</option>
                  //   <option value="Order : Shipped">Order : Shipped</option>
                  //   <option value="Pending for Approval">
                  //     Pending for Approval
                  //   </option>
                  //   <option value="Approved">Approved</option>
                  //   <option value="Rejected">Rejected</option>
                  //   <option value="Cancellation Pending">
                  //     Cancellation Pending
                  //   </option>
                  //   <option value="Cancellation Approved">
                  //     Cancellation Approved
                  //   </option>
                  //   <option value="Cancellation Reject">
                  //     Cancellation Reject
                  //   </option>
                  // </select>
                  <input
                    className="w-[100px] border border-gray-300 rounded-md p-1 px-2"
                    onChange={(e) => handleApiCall(e.target.value)}
                    placeholder="Status"
                  />
                ) : (
                  show_name
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!isLoading && !orders ? (
            <tr>
              <td colSpan={ORDER_OUTLINE.length} className="text-center">
                <h1>No Order Match</h1>
              </td>
            </tr>
          ) : isLoading ? (
            <tr>
              <td colSpan={ORDER_OUTLINE.length} className="text-center">
                <Loading />
              </td>
            </tr>
          ) : orders?.length > 0 ? (
            orders?.map((order) => (
              <tr
                key={order?.id}
                className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                {ORDER_OUTLINE.map(({ api_name }) => {
                  return (
                    <td
                      key={api_name}
                      className="px-6 py-4 max-w-32 overflow-x-auto custom-scrollbar"
                    >
                      {api_name === "Stage" ? (
                        <span className="inline-block">
                          <Badge
                            className="shadow-md"
                            color={`${
                              order?.["Stage"] === "Confirm"
                                ? "success"
                                : order?.["Stage"] === "Void"
                                ? "failure"
                                : order?.["Stage"]?.startsWith?.("Order : ")
                                ? "warning"
                                : "info"
                            }`}
                          >
                            {order?.["Stage"] === "Confirm"
                              ? "Stock Confirm"
                              : order?.[api_name]}
                          </Badge>
                        </span>
                      ) : api_name === "Action" ? (
                        <OrderListActionButton order={order} />
                      ) : api_name === "Name" ? (
                        <Link
                          className={`font-semibold ${
                            order["Stage"] === "Confirm" && "text-blue-600"
                          }`}
                          to={`/order-history/${order?.id}`}
                        >
                          {order[api_name]}
                        </Link>
                      ) : api_name === "Versioning_No" ? (
                        <span
                          className={`font-semibold ${
                            order[api_name] ? "text-green-800" : ""
                          }`}
                        >
                          {order[api_name] ?? "N/A"}
                        </span>
                      ) : api_name === "Grand_Total" ? (
                        order?.Total_Custom_Discount_1 > 0 ? (
                          order?.Total_Distributor_Price
                        ) : (
                          order?.Grand_Total
                        )
                      ) : (
                        order[api_name]
                      )}
                    </td>
                  );
                })}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={(ORDER_OUTLINE.length ?? 0) + 1}
                className="text-center py-6 text-orange-500"
              >
                No Data Available?
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OrderLists;
